<template>
  <div class="w-50 cardRegister container px-2 py-2 border border-secondary-subtle position-fixed top-50 start-50 translate-middle w-50 p-3">
    <button class="btn-close float-end me-2 mt-1" @click.prevent="close"></button>
    <h4 class="mt-3"><strong>Registrar precio</strong></h4>
    <form action="" class="w-75 mx-auto">
      <div class="row aling-items-center mt-3 mb-3">
        <div class="col-sm-5">
          <label for="pricetype">Línea:</label>
        </div>
        <div class="col-sm-5">
          <select class="form-select" id="pricetype" v-model="pricetype">
            <option value="0" selected>Seleccione una opción...</option>
            <option value="lam">Láminas</option>
            <option value="perf">Perfiles</option>
            <option value="tub">Tubos</option>
          </select>
        </div>
      </div>
      <div class="row aling-items-center mt-3 mb-3">
        <div class="col-sm-5">
          <label for="pricename">Nombre del precio:</label>
        </div>
        <div class="col-sm-5">
          <input
            type="text"
            v-model="pricename"
            class="form-control"
            id="pricename"
          />
        </div>
      </div>
      <div class="row aling-items-center mt-3 mb-3">
        <div class="col-sm-5">
          <label for="pricevalue">Valor: </label>
        </div>
        <div class="col-sm-5">
          <input
            type="number"
            v-model="pricevalue"
            class="form-control"
            id="pricevalue"
            step="100"
            min="0"
          />
        </div>
      </div>
      <div>
        <button class="btn btn-danger mb-2" @click.prevent="registerPrice">
          Guardar precio
        </button>
      </div>
    </form>
  </div>
</template>
<script>
import axios from "axios";
export const RUTA_SERVIDOR = process.env.VUE_APP_RUTA_BACKEND;
export default {
  data() {
    return {
      pricetype: "",
      pricename: "",
      pricevalue: 0,
    };
  },
  methods: {
    async registerPrice() {
      if (
        this.pricetype === "" ||
        this.pricename === "" ||
        this.pricevalue === 0
      ) {
        alert("Alguno de los campos está vácio, no se puede crear el precio.");
      } else {
        let formData = new FormData();
        formData.append("pricetype", this.pricetype);
        formData.append("name", this.pricename);
        formData.append("value", this.pricevalue);
        try {
          let res = await axios.post(
            RUTA_SERVIDOR + "api/price/create",
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
                Authorization: "Bearer " + localStorage.getItem("token"),
              },
            }
          );
          console.log(res.data);
          if (!res.data) {
            console.log("There has been a different error with the data.");
          } else {
            alert("Precio creado con exito");
            this.cleanfields();
            this.$emit("hidePopUp", false);
            location.reload();
          }
        } catch (err) {
          console.log(`There has been an error ${err}`);
        }
      }
    },
    cleanfields() {
      this.pricetype = "0";
      this.pricename = "";
      this.pricevalue = 0;
    },
    close() {
      this.$emit("hidePopUp", false)
    },
  },
};
</script>